(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["herio-decoration"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var decorations = document.querySelectorAll('.herio-decoration');
    if (!decorations.length) return;

    // 1. Pick a random decoration
    var randomIndex = Math.floor(Math.random() * decorations.length);
    var activeDecoration = decorations[randomIndex];
    activeDecoration.classList.add('is-active');

    // 2. Assign random durations to each path for organic stagger
    var paths = activeDecoration.querySelectorAll('path');
    var minDuration = 700;  // ms
    var maxDuration = 1400; // ms

    paths.forEach(function(path) {
      var randomDuration = minDuration + Math.random() * (maxDuration - minDuration);
      path.style.setProperty('--duration', Math.round(randomDuration) + 'ms');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
